import { graphql } from '../../gql';

export const FINAL_FORMS_BY_INTERNAL_NAME = graphql(`
  query finalFormsByInternalname($internalNames: [String!]!) {
    someFinalForms(internalNames: $internalNames) {
      ...AmendedFormFields
    }
  }
`);
